import React, { useRef, useEffect, useState } from 'react';
import ReactHlsPlayer from 'react-hls-player';
import VideoOverlay from './VideoOverlay';
import useApiError from 'packages/novous_web/src/api/useApiError';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import { Typography } from '@mui/material';
import MP4VideoPlayer from './Mp4VideoPlayer';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';

type VideoPlayerProps = {
  availableHeight: number;
  availableWidth: number;
  streamUrl: string;
  showVodLoading?: boolean;
  cameraList?: any
  controls?: boolean;
  duration?: number;
  playing?: boolean;
  cameraId?: string;
  deviceId?: string;
  sdVideo?: boolean;
  fullMode?: boolean;
  customerId?: string; // Added customerId prop

  singleFullMode?: boolean;
  mlParams?: any;

  cooldown?: boolean;
  cooldownTime?: number;
  fetchBlurFalse?: boolean;
  blurEnable?: boolean; // Added fetchBlurFalse prop
  deviceType?: string

};

interface CameraUrl {
  name: string;
  url: string;
}


const VideoPlayer: React.FC<VideoPlayerProps> = ({
  availableHeight,
  streamUrl,
  availableWidth,
  fullMode = false,
  playing = true,
  cameraList,
  showVodLoading = false,
  duration = 0,
  controls = false,
  cameraId,
  deviceId,
  sdVideo,
  singleFullMode,
  mlParams,
  customerId,

  cooldown,
  cooldownTime,
  fetchBlurFalse, // Added fetchBlurFalse prop
  blurEnable,
  deviceType
}) => {
  console.log(cameraList, 'snkcksncksnc')
  const playerRef = useRef<HTMLVideoElement>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { user } = useAuth();


  // Maintain aspect ratio (16:9)
  const aspectRatio = 16 / 9;

  // Fit the video fully inside the available height and width (contain logic)
  const heightBasedWidth = availableHeight * aspectRatio;
  const widthBasedHeight = availableWidth / aspectRatio;
  const [overlayReady, setOverlayReady] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const MAX_RETRIES = 5;
  const RETRY_DELAY = 5000; // 5 seconds
  const [playerSize, setPlayerSize] = useState({ width: 0, height: 0 });
  const [blurStatus, setBlurStatus] = useState<boolean>(false);
  const [VideoReady, setVideoReady] = useState<boolean>(true);
  const [toast, setToast] = useState({ open: false, message: '', type: 'error' });
  const [videoAvailable, setVideoAvailable] = useState({ isAvailable: false, value: 'Please Select Time Stamp to Play SD-Card Videos...' });
  const [loadingMessage, setloadingMessage] = useState('Please Select Time Stamp to Play SD-Card Videos...');

  // useEffect(() => {
  //   if(streamUrl=== ''){
  //     setVideoAvailable({ isAvailable: false, value: 'Please Select Time Stamp to Play SD-Card Videos...' });
  //     setloadingMessage('Please Select Time Stamp to Play SD-Card Videos...');
  //   }
  // }, [streamUrl])

  useEffect(() => {
    if (!overlayReady) return;

    const updateSize = () => {
      if (playerRef.current) {
        const rect = playerRef.current.getBoundingClientRect();
        setPlayerSize({ width: rect.width, height: rect.height });
      }
    };

    updateSize(); // initial call

    const resizeObserver = new ResizeObserver(() => updateSize());
    if (playerRef.current) {
      resizeObserver.observe(playerRef.current);
    }

    return () => {
      if (playerRef.current) {
        resizeObserver.unobserve(playerRef.current);
      }
    };
  }, [overlayReady, playerRef.current]);

  // useEffect(()=>{
  //   if (!cameraId || cameraId == "04") {
  //     console.log('Making overlayReady false yashxx 81');

  //     setOverlayReady(false)
  //   }

  // },[availableHeight, availableWidth,cameraList])
  // const normalizedCameraId = cameraId === "2" ? "04" : cameraId;
  const normalizedCameraId = cameraId === "2" ? "04" : cameraId;


  useEffect(() => {
    if (normalizedCameraId !== "04") {
      console.log('Making overlayReady true yashxx 91');
      setOverlayReady(true); // Default ready if no overlay is required
    }
  }, [normalizedCameraId, cameraList]);

  useEffect(() => {
    if (playerRef.current && overlayReady && playing) {
      playerRef.current.play().catch((error) => console.error("Video playback error:", error));
    }
  }, [overlayReady, playing]);

  let finalWidth: number;
  let finalHeight: number;

  if (heightBasedWidth <= availableWidth) {
    // Height is the limiting factor
    finalHeight = availableHeight;
    finalWidth = heightBasedWidth;
  } else {
    // Width is the limiting factor
    finalWidth = availableWidth;
    finalHeight = widthBasedHeight;
  }

  useEffect(() => {
    if (playerRef.current) {
      playerRef.current.style.width = `${finalWidth}px`;
      playerRef.current.style.height = `${finalHeight}px`;
      playerRef.current.style.objectFit = 'contain'; // Ensures full video is visible

      playerRef.current.controls = true;
    }
  }, [finalWidth, finalHeight]);

  const {
    data: mlParamsData,
    error: mlParamsError,
    loading: mlParamsLoading,
    fetchData: mlParamsRequestData,
  } = useApiError<any>(`${API_ENDPOINTS.videoBlur.BLUR_CROPPED_VIDEO}/${deviceId}`, "GET"
  );

  useEffect(() => {
    let retryTimeout: NodeJS.Timeout;

    const checkVideoUrl = async () => {
      if (streamUrl && streamUrl !== '') {
        try {
          const response = await fetch(streamUrl, {
            method: 'GET',
          });

          if (!response.ok) {
            console.error(`Stream URL Error: ${response.status} ${response.statusText}`);
            setloadingMessage('Stream Loading....');

            retryTimeout = setTimeout(checkVideoUrl, RETRY_DELAY);
          } else {
            console.log('Stream URL is available');
            setVideoAvailable({ isAvailable: true, value: 'Available' });
          }
        } catch (error) {
          console.error('Error fetching stream URL:', error);
          retryTimeout = setTimeout(checkVideoUrl, RETRY_DELAY);
        }
      }
    };

    if (!videoAvailable.isAvailable) {
      checkVideoUrl();
    }
    else if (streamUrl == '') {
      setVideoAvailable({ isAvailable: false, value: 'Connecting to video stream....' });
      setloadingMessage('Connecting to video stream....');
    }

    return () => {
      if (retryTimeout) clearTimeout(retryTimeout);
    };
  }, [streamUrl]);


  useEffect(() => {
    if (mlParamsError) {
      setToast({ open: true, message: 'Error while fetching ML Params', type: 'error' });
    }
  }, [mlParamsError])

  useEffect(() => {
    if (deviceId && streamUrl) {
      mlParamsRequestData(deviceId);
    }
  }, [deviceId, streamUrl])

  // const staticMlParams = {
  //     data: {
  //         data: {
  //             dsmCabin: {
  //                 dsm_cabin_driver_crop_height: 512,
  //                 dsm_cabin_driver_crop_width: 384,
  //                 dsm_cabin_driver_crop_x: 60,
  //                 dsm_cabin_driver_crop_y: 20
  //             },
  //         },
  //     },
  // };

  mlParams = mlParamsData;

  useEffect(() => {
    const handleFullscreenChange = () => {
      const fullscreenElement = document.fullscreenElement || document.fullscreenElement || document.fullscreenElement || document.fullscreenElement;
      setIsFullscreen(!!fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, [isFullscreen]);

  const fullModeWidth = window.innerWidth;
  const fullModeHeight = window.innerHeight;


  if (fullMode) {
    if (fullModeHeight * aspectRatio <= fullModeWidth) {
      finalHeight = fullModeHeight;
      finalWidth = fullModeHeight * aspectRatio;
    } else {
      finalWidth = fullModeWidth;
      finalHeight = fullModeWidth / aspectRatio;
    }
  } else {
    if (heightBasedWidth <= availableWidth) {
      finalHeight = availableHeight;
      finalWidth = heightBasedWidth;
    } else {
      finalWidth = availableWidth;
      finalHeight = widthBasedHeight;
    }
  }

  const handleBlurStatus = (blurStatus: boolean) => {
    console.log('handleBlurStatus called', blurEnable);
    setVideoReady(blurEnable ? true : blurStatus)
    setBlurStatus(blurEnable ? true : blurStatus)
  }

  console.log('overlayReady yashxx 181', deviceType);
  // Flatten cameraList and get cameraName's first character based on cameraId
  let cameraNameInitial: string | null = null;

  if (Array.isArray(cameraList)) {
    const flatCameraList = cameraList.flat();
    const matchedCamera = flatCameraList.find((cam) => cam.cameraId === cameraId);
    if (matchedCamera && matchedCamera.cameraName) {
      cameraNameInitial = matchedCamera.cameraName.charAt(0);
    }
  }



  return (
    <>
      <div
        className="flex items-center justify-center text-white"
        style={{
          width: isFullscreen ? '100vw' : '100%',
          height: isFullscreen ? '100vh' : finalHeight,
          // height: availableHeight,
          position: isFullscreen ? 'fixed' : 'relative',
          left: isFullscreen ? '0' : '0',
          top: isFullscreen ? '0' : '0',
          bottom: isFullscreen ? '0' : '0',
          right: isFullscreen ? '0' : '0',
        }}
      >
        {mlParamsData && normalizedCameraId === "04" && (
          <VideoOverlay
            deviceId={deviceId}
            customerId={customerId}
            streamUrl={streamUrl}
            sdVideo={sdVideo}
            fullMode={fullMode}
            singleFullMode={singleFullMode}
            mlParams={mlParams}
            onOverlayReady={(value: boolean) => {
              console.log('Making overlayReady true yashxx 203', value);
              setOverlayReady(blurEnable ? true : value);
            }}
            setBlurStatus={handleBlurStatus}
            playerSize={playerSize}
            fetchBlurFalse={fetchBlurFalse}
            blurEnable={blurEnable}
            deviceType={deviceType}
          />
        )}

        {cameraNameInitial && (
          <Typography
            variant="body2"
            color="primary"
            fontWeight={600}
            fontSize={18}
            className="absolute top-[5px] right-[5px] z-10 bg-white w-[40px] h-[40px] flex items-center justify-center rounded-full"
          >
            {cameraNameInitial}
          </Typography>
        )}
        {(overlayReady || !VideoReady) && (blurEnable ? true : (videoAvailable.isAvailable && !cooldown)) && (
          <ReactHlsPlayer
            className={`${isFullscreen ? 'position-absolute react-player' : 'react-player'}`}
            autoPlay
            playerRef={playerRef}
            src={streamUrl}
            controls={false}
            hlsConfig={{
              lowLatencyMode: true,
              backBufferLength: 90,
              maxLiveSyncPlaybackRate: 1.5,
              liveSyncDuration: 3,
              liveMaxLatencyDuration: 5,
              maxBufferLength: 30,
              enableWorker: true,
            }}
            muted
            style={{
              width: `${finalWidth}px`,
              height: `${finalHeight}px`,
              background: 'black',
              objectFit: 'contain',
            }}
          />
        )}

        {/* <div className="flex items-center justify-center text-white" style={{
          width: `${finalWidth}px`,
          height: `${finalHeight}px`,
          background: 'black'
        }}>
          {cooldown &&
            <Typography variant="h6">Please wait {cooldownTime} seconds for video data...</Typography>
          }
          {!videoAvailable.isAvailable && showVodLoading &&
            <Typography variant="h6">{loadingMessage}</Typography>
          }
        </div> */}
        {cooldown &&
          <div className="flex items-center justify-center text-white" style={{
            width: `${finalWidth}px`,
            height: `${finalHeight}px`,
            background: 'black'
          }}>
            <Typography variant="h6">Please wait {cooldownTime} seconds for video data...</Typography>
          </div>
        }
        {!videoAvailable.isAvailable && showVodLoading &&
          <div className="flex items-center justify-center text-white" style={{
            width: `${finalWidth}px`,
            height: `${finalHeight}px`,
            background: 'black'
          }}>
            <Typography variant="h6">{loadingMessage}</Typography>
          </div>
        }
      </div>
      <AlertToast
        open={toast.open}
        message={toast.message}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        type={toast.type as any}
        duration={2000}
      />
    </>
  );
};

export default React.memo(VideoPlayer);

